import React, { useEffect, useState } from 'react';
import styles from '../ErrorPages/ErrorPage.module.css';
import { Typography, CircularProgress } from '@mui/material';
import SignUpBannerFooter from '../../components/Footer/SignUpBannerFooter';
import { useLocation, useNavigate } from 'react-router-dom';
import { unsubscribeEmail } from '../../services/HttpService';

const UnsubscribeEmail: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'processing' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const emailParam = searchParams.get('email');
    const tokenParam = searchParams.get('token');

    if (!emailParam || !tokenParam) {
      setStatus('error');
      setMessage('Missing email or token in the request.');
      return;
    }

    setEmail(emailParam);
    setToken(tokenParam);
  }, [location]);

  const handleUnsubscribe = async () => {
    if (!email || !token) return;

    setStatus('processing');
    try {
      await unsubscribeEmail(email, token);
      setStatus('success');
      setMessage('You have successfully unsubscribed from email services.');
    } catch (error: any) {
      console.error(error);
      setStatus('error');
      setMessage(error.message || 'Something went wrong while unsubscribing.');
    }
  };

  return (
    <div className={styles.ErrorPage} style={{ background: '#FFF' }}>
      <section id="UnsubscribeEmailTitle" className={styles.ErrorPageTitle} />

      <div className={styles.PageNotFound}>
        <div className={styles.PageNotFoundCard}>
          <div className={styles.PageNotFoundCardContent}>
            <Typography variant="h2" style={{ color: '#1b1d37' }}>
              {status === 'success' && 'Unsubscribed'}
              {status === 'error' && 'Error'}
              {status === 'processing' && 'Processing...'}
              {status === 'idle' && 'Unsubscribe from Emails'}
            </Typography>

            <br />

            {status === 'processing' ? (
              <CircularProgress />
            ) : (
              <>
                <Typography variant="body1" style={{ textAlign: 'center' }}>
                  {status === 'idle' &&
                    `Are you sure you want to unsubscribe from receiving future emails at ${email}?`}
                  {(status === 'success' || status === 'error') && message}
                </Typography>

                <br />

                {status === 'idle' ? (
                  <button
                    className={'PrimaryButton'}
                    style={{ width: '260px' }}
                    onClick={handleUnsubscribe}
                  >
                    Yes, unsubscribe me
                  </button>
                ) : (
                  <button className={'PrimaryButton'} style={{ width: '200px' }} onClick={() => navigate('/')}>
                    Back to home
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div style={{ height: '380px' }}></div>

      <SignUpBannerFooter />
    </div>
  );
};

export default UnsubscribeEmail;
